import { atom } from 'jotai'

// The response-tap span key — relocated from the (now-deleted) Redux selectors; this atom owns it.
export const MAIN_RESPONSE_TAP_KEY = 'rTapNumber325017'

/**
 * Response-tap slice state — a plain object map of response-tap span keys to their phone
 * numbers. Fully on Jotai: readers and the writer (ResponseTap.js) use these atoms directly.
 * Redux (and the ReduxAtomBridge) have been removed; these atoms are the source of truth.
 */
export type ResponseTapNumbersMap = Record<string, string>;

export const responseTapInitialState: ResponseTapNumbersMap = {
  [MAIN_RESPONSE_TAP_KEY]: '0330 102 8256', // default contact number — kept identical to the reducer
}

// Base atom — the source of truth for the response-tap numbers map.
export const responseTapAtom = atom<ResponseTapNumbersMap>(responseTapInitialState)

// Derived read atom — replaces the getMainResponseNumber Ramda selector. Defaults to '' to
// match R.pathOr('', ...) when the key is absent.
export const mainResponseNumberAtom = atom((get) => get(responseTapAtom)[MAIN_RESPONSE_TAP_KEY] ?? '')

// Write atom — replaces the SET_RESPONSE_TAP_NUMBER action. Merges the payload into the map,
// mirroring the reducer's Object.assign semantics.
export const setResponseTapNumberAtom = atom(null, (get, set, payload: ResponseTapNumbersMap) => {
  set(responseTapAtom, { ...get(responseTapAtom), ...payload })
})
